import type { FundraisingGoalBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface FundraisingGoalBlockEditorProps {
  content: FundraisingGoalBlockContent | null
  onChange: (content: FundraisingGoalBlockContent) => void
}

export function FundraisingGoalBlockEditor({
  content,
  onChange,
}: FundraisingGoalBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<FundraisingGoalBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Fundraising Goal</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? ""}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Support our cause"
          />
        </div>
        <div>
          <Label>Goal Amount</Label>
          <Input
            type="number"
            min={0}
            value={c.goal_amount ?? 0}
            onChange={(e) => update({ goal_amount: Number(e.target.value) || 0 })}
            placeholder="10000"
          />
        </div>
        <div>
          <Label>Raised Amount</Label>
          <Input
            type="number"
            min={0}
            value={c.raised_amount ?? 0}
            onChange={(e) => update({ raised_amount: Number(e.target.value) || 0 })}
            placeholder="0"
          />
        </div>
        <div>
          <Label>Currency</Label>
          <Input
            value={c.currency ?? "USD"}
            onChange={(e) => update({ currency: e.target.value })}
            placeholder="USD"
          />
        </div>
        <div>
          <Label>Label</Label>
          <Input
            value={c.label ?? "raised"}
            onChange={(e) => update({ label: e.target.value })}
            placeholder="raised"
          />
        </div>
        <div>
          <Label>CTA Text</Label>
          <Input
            value={c.cta_text ?? ""}
            onChange={(e) => update({ cta_text: e.target.value })}
            placeholder="Donate now"
          />
        </div>
        <div>
          <Label>CTA URL</Label>
          <Input
            value={c.cta_url ?? ""}
            onChange={(e) => update({ cta_url: e.target.value })}
            placeholder="https://..."
          />
        </div>
      </CardContent>
    </Card>
  )
}
